var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-item',{staticClass:"kst-action-item",attrs:{"paddingless":"","aria-role":"listitem"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }